module.exports = __webpack_public_path__ + "static/media/send.cdaac4cc.svg";